module.exports = __webpack_public_path__ + "img/img2.93a10d39.png";